import { useQuery } from 'react-query'
import { getContractById } from '../../contracts'

export default function useContract(id: string) {
  const { data, error, isLoading } = useQuery(['contract', id], () =>
    getContractById(id)
  )
  return { data, error, isLoading }
}
